import * as React from 'react';
import * as styled from './styled';
import {ContextProvider} from './Context';
import Container from 'containers/Container';
import {Header} from './components/Header';
import {Content} from './components/Content';
import {Footer} from './components/Footer';
import {TaskProgressProps, ViewMode} from './types';

/**
 * The task progress component.
 * @param {TaskProgressProps} props
 * @return {React.ReactElement<TaskProgressProps>}
 * @constructor
 */
export default function TaskProgress(
    props: TaskProgressProps,
): React.ReactElement<TaskProgressProps> {
  const [
    mode, setMode,
  ] = React.useState<ViewMode>(
      props.defaultMode || ViewMode.Page,
  );

  return (
    <ContextProvider value={{
      states: {
        mode: {
          state: mode,
          setState: setMode,
        },
      },
    }}>
      <styled.Wrapper>
        <Container>
          <Header />
          <Content />
        </Container>
        <Footer />
      </styled.Wrapper>
    </ContextProvider>
  );
}
